<template>
  <div v-if="!loading">
    <div class="header-2">
      <div class="page-header header-filter">
        <div
          :style="{
            backgroundImage:
              'url(' + options.defaultAirport.backgroundImageUrl + ')',
          }"
          class="page-header-image"
          style="background-image: url('img/bg-default.png')"
        />
        <div class="content-center">
          <div class="container">
            <div class="row">
              <div class="col-md-10 ml-auto mr-auto text-center">
                <h1 class="title">SAVE BIG ON AIRPORT PARKING</h1>
                <h3 class="description">
                  We have the best deals for airport parking lots!
                </h3>
              </div>
              <div
                :class="options.allowLocationSearch ? 'col-md-10' : 'col-md-7'"
                class="ml-auto mr-auto"
              >
                <h5 class="locations mt-5 text-center">
                  <span
                    v-for="(item, index) of airports"
                    :key="index"
                    class="py-1 d-inline-block"
                  >
                    <a
                      href="javascript:void(0);"
                      class="text-light mx-2 text-nowrap"
                      @click="viewAirport(item)"
                    >
                      {{ item.city }}({{ item.code }})
                    </a>
                    <span v-if="index < airports.length - 1">|</span>
                  </span>
                </h5>
                <!-- <div class="card card-raised card-form-horizontal">
                  <div id="scroll" class="card-body">
                    <form>
                      <div class="row align-items-end">
                        <div
                          v-if="options.allowLocationSearch"
                          class="col-md-4"
                        >
                          <label class="label">Departure Airport</label>
                          <ApcAutocomplete
                            v-popover:popover
                            left-icon="bx bxs-plane-alt"
                            @submit="airport = $event"
                            @focus="popover = false"
                          />
                          <el-popover
                            ref="popover"
                            v-model="popover"
                            trigger="manual"
                            placement="bottom-start"
                            popper-class="popover popover-danger popover-apc"
                          >
                            <div class="popover-body">
                              Please enter your departure airport.
                            </div>
                          </el-popover>
                        </div>
                        <div
                          :class="
                            options.allowLocationSearch
                              ? 'col-md-5'
                              : 'col-md-8'
                          "
                        >
                          <label class="label">Check-In / Check-Out</label>
                          <APCDateRangePicker
                            :max-length="options.maxReservationDays"
                            @update="dateRange = $event"
                            @scrollUp="onScrollUp"
                          />
                        </div>
                        <div
                          :class="
                            options.allowLocationSearch
                              ? 'col-md-3'
                              : 'col-md-4'
                          "
                        >
                          <n-button
                            type="danger"
                            class="btn-search"
                            block
                            @click.native="onSearch"
                          >
                            {{ search ? "" : "Search" }}
                            <i v-if="search" class="bx bx-loader bx-spin" />
                          </n-button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-md-4">
          <div class="info info-hover">
            <div class="icon icon-primary">
              <i class="now-ui-icons business_money-coins" />
            </div>
            <h4 class="info-title">Low Cost</h4>
            <p class="description">
              Save money and see options across airport parking options.
            </p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="info info-hover">
            <div class="icon icon-success">
              <i class="now-ui-icons design_scissors" />
            </div>
            <h4 class="info-title">Cancelation</h4>
            <p class="description">
              You can cancel up to 24 hours before your reservation unless specified otherwise on the reservation page.
            </p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="info info-hover">
            <div class="icon icon-warning">
              <i class="now-ui-icons sport_user-run" />
            </div>
            <h4 class="info-title">Super Fast</h4>
            <p class="description">
              Low effort to find and book reservation in under 3 minutes.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="container">
        <div class="row">
          <div v-for="offer in offers.offers" :key="offer.id" class="col-md-3">
            <card>
              <img
                slot="image"
                :src="offer.locationLogo"
                class="rounded d-none d-md-block"
                alt=""
              />
              <div class="d-none d-md-block">
                <h4 class="card-title">{{ offer.locationName }}</h4>
                <h6 class="category text-primary">{{ offer.name }}</h6>
              </div>
              <div class="row align-items-center mb-3 d-flex d-md-none">
                <div class="col-auto pr-0">
                  <img
                    slot="image"
                    :src="offer.locationLogo"
                    class="rounded"
                    width="50"
                    alt=""
                  />
                </div>
                <div class="col">
                  <h4 class="card-title mt-0">{{ offer.locationName }}</h4>
                  <h6 class="category text-primary">{{ offer.name }}</h6>
                </div>
              </div>
              <div
                v-for="amenitie in offer.amenities"
                :key="amenitie.name"
                class="amenitie"
              >
                <i :class="amenitie.icon" class="bx mr-1" />{{ amenitie.name }}
              </div>
              <div class="row align-items-center mt-2">
                <div class="col-auto">
                  <h3 class="mb-0">
                    <sup>$</sup>{{ formatter(offer.dailyBaseRate)
                    }}<sup>{{ formatter(offer.dailyBaseRate, 1) }}</sup>
                  </h3>
                  <span class="per-day">per day</span>
                </div>
                <div class="col text-right">
                  <n-button
                    :disabled="!offer.available"
                    class="m-0"
                    type="info"
                    @click.native="onSelectOffer(offer)"
                  >
                    Book
                  </n-button>
                  <img
                    v-if="!offer.available"
                    src="img/sold-out.png"
                    class="sold-out"
                    height="40"
                  />
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import axios from "axios";
import { mapState, mapMutations } from "vuex";
import { Popover } from "element-ui";
import { Button, Card, FormGroupInput } from "@/components";
import ApcAutocomplete from "@/pages/components/APCAutocomplete.vue";
import APCDateRangePicker from "@/pages/components/APCDateRangePicker.vue";

export default {
  components: {
    [Popover.name]: Popover,
    Card,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    ApcAutocomplete,
    APCDateRangePicker,
  },
  data() {
    return {
      airport: {},
      airports: [],
      dateRange: {
        startDate: moment().add(1, "hours").startOf("hour").toDate(),
        endDate: moment().add(75, "hours").startOf("hour").toDate(),
      },
      offers: {},
      popover: false,
      search: false,
    };
  },
  computed: {
    ...mapState(["loading", "options"]),
  },
  created() {
    this.setLoading(false);
    // this.getOffers();
    this.getAirports();
    if (this.$route.query.couponCode) {
      sessionStorage.setItem('couponCode', couponCode)
    }
  },
  methods: {
    ...mapMutations(["setLoading"]),
    getAirports() {
      axios.get("airport").then((res) => {
        console.log("airports", res);
        this.airports = res.data;
        this.setLoading(false);
      }).catch(() => {
        this.setLoading(false);
      });
    },
    getOffers(params, redirect) {
      const airportCode = params
        ? params.airportCode
        : this.options.defaultAirport.code;
      const startDate = params
        ? params.start.split(" ")[0]
        : moment(this.dateRange.startDate).format("YYYY-MM-DD");
      const endDate = params
        ? params.end.split(" ")[0]
        : moment(this.dateRange.endDate).format("YYYY-MM-DD");
      const startTime = params
        ? params.start.split(" ")[1]
        : moment(this.dateRange.startDate).format("HH:mm");
      const endTime = params
        ? params.end.split(" ")[1]
        : moment(this.dateRange.endDate).format("HH:mm");
      let query = `apc/offer?airportCode=${airportCode}&startDate=${startDate}&endDate=${endDate}&startTime=${startTime}&endTime=${endTime}`;
      if (sessionStorage.getItem('couponCode')) {
        query += `&couponCode=${sessionStorage.getItem('couponCode')}`;
      }
      axios.get(query).then((res) => {
        const { data } = res;
        console.log("offer: ", data);
        if (!redirect) {
          const offers = data.offers.sort((a, b) =>
            a.available < b.available || b.dailyBaseRate < a.dailyBaseRate
              ? 1
              : b.available < a.available || a.dailyBaseRate < b.dailyBaseRate
              ? -1
              : 0
          );
          this.offers = {
            offersDescription: data.offersDescription,
            offers,
          };
        } else {
          this.$router.push({
            name: redirect,
            params: { initialOffer: data },
            query: { ...params },
          });
        }
        this.search = false;
        this.setLoading(false);
      });
    },
    onSearch() {
      const airportCode = this.options.allowLocationSearch
        ? this.airport.code
        : this.options.defaultAirport.code;
      const name = this.options.allowLocationSearch
        ? this.airport.name
        : this.options.defaultAirport.name;
      if (!airportCode) {
        this.popover = true;
        return;
      }
      const start = moment(this.dateRange.startDate).format("YYYY-MM-DD HH:mm");
      const end = moment(this.dateRange.endDate).format("YYYY-MM-DD HH:mm");
      this.search = true;
      const params = {
        name,
        airportCode,
        start,
        end,
        lat: this.options.allowLocationSearch
          ? this.airport.coordinate.coordinates[1]
          : this.options.defaultAirport.coordinate.coordinates[1],
        lng: this.options.allowLocationSearch
          ? this.airport.coordinate.coordinates[0]
          : this.options.defaultAirport.coordinate.coordinates[0],
      };
      this.getOffers(params, "/offers");
    },
    formatter(number, index = 0) {
      return ("" + number).split(".")[index];
    },
    onSelectOffer(offer) {
      const startDate = moment(this.dateRange.startDate).format("YYYY-MM-DD");
      const endDate = moment(this.dateRange.endDate).format("YYYY-MM-DD");
      const startTime = moment(this.dateRange.startDate).format("HH:mm");
      const endTime = moment(this.dateRange.endDate).format("HH:mm");
      this.$router.push({
        name: "/reservation",
        params: { initialOffer: offer },
        query: {
          id: offer.rateId,
          start: startDate + " " + startTime,
          end: endDate + " " + endTime,
          name: this.options.defaultAirport.name,
          airportCode: this.options.defaultAirport.code,
          lat: this.options.defaultAirport.coordinate.coordinates[1],
          lng: this.options.defaultAirport.coordinate.coordinates[0],
        },
      });
    },
    onScrollUp() {
      if (window.innerWidth > 768) {
        const container = this.$el.querySelector("#scroll");
        window.scrollTo(0, container.scrollHeight);
      }
    },
    viewAirport(item) {
      console.log("item", item);
      this.$router.push({
        name: "/offers",
        query: {
          name: item.name,
          airportCode: item.code,
          lat: item.coordinate.coordinates[1],
          lng: item.coordinate.coordinates[0],
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.page-header {
  @media (min-width: 772px) {
    min-height: 50vh !important;
  }

  .page-header-image {
    background-position: center center !important;
  }

  .container {
    text-align: left !important;

    .title {
      @media (max-width: 771px) {
        font-size: 2.25em;
      }
    }

    .description {
      color: white;
      margin-bottom: 0 !important;
      font-weight: bold;

      @media (max-width: 771px) {
        font-size: 1.5em;
      }
    }

    .label {
      color: black;
      font-weight: normal;
      margin-bottom: 4px;
    }

    .btn-search {
      @media (max-width: 771px) {
        margin-top: 16px;
      }
    }
  }
}

::v-deep .card-image {
  img {
    width: 100%;
  }
}

.amenitie {
  margin-bottom: 1px;
}
.per-day {
  display: block;
  position: relative;
  top: -6px;
  font-size: 0.8rem;
}

.popover-body {
  padding: 2px 8px;
  color: white;
}

.sold-out {
  position: absolute;
  right: 16px;
  top: 0;
  transform: rotate(-25deg);
}
</style>
<style lang="scss">
@import "./../assets/sass/now-ui-kit/variables";
.popover-apc {
  margin-top: 8px;

  .popper__arrow {
    left: 16px !important;
    &::after {
      border-bottom-color: $danger-color !important;
    }
  }
}
</style>
